// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"waveText__wrapper__3SdLa","text":"waveText__text__2SYLE","letter":"waveText__letter__2kTM3","wave":"waveText__wave__285Cj","spacer":"waveText__spacer__1WoWw"};